import { useEffect, useState } from "react";
import { DownloadSimple, X } from "@phosphor-icons/react";

/** Reusable install prompt for Android (beforeinstallprompt) + iOS hint */
export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [iosHint, setIosHint] = useState(false);

  useEffect(() => {
    // Already installed?
    const standalone =
      window.matchMedia?.("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;
    if (standalone) return;

    // Dismissed recently?
    const dismissedAt = parseInt(localStorage.getItem("mise_install_dismissed") || "0", 10);
    if (Date.now() - dismissedAt < 7 * 24 * 60 * 60 * 1000) return;

    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", onBeforeInstall);

    // iOS Safari (no beforeinstallprompt support)
    const ua = window.navigator.userAgent || "";
    const isIos = /iphone|ipad|ipod/i.test(ua) && !/crios|fxios/i.test(ua);
    if (isIos) {
      const t = setTimeout(() => { setIosHint(true); setShow(true); }, 4000);
      return () => { clearTimeout(t); window.removeEventListener("beforeinstallprompt", onBeforeInstall); };
    }

    return () => window.removeEventListener("beforeinstallprompt", onBeforeInstall);
  }, []);

  const dismiss = () => {
    localStorage.setItem("mise_install_dismissed", String(Date.now()));
    setShow(false);
  };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="install-prompt"
      className="fixed bottom-20 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-sm z-40 fade-up"
    >
      <div className="rounded-2xl bg-white border border-[hsl(var(--border))] shadow-2xl p-5">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-[hsl(var(--primary))]/10 flex items-center justify-center shrink-0">
            <DownloadSimple size={20} weight="duotone" className="text-[hsl(var(--primary))]" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-serif text-lg leading-tight">Instala MIZETA en tu móvil</p>
            <p className="mt-1 text-sm text-[hsl(var(--muted-foreground))] leading-relaxed">
              {iosHint
                ? "Toca el botón Compartir de Safari y luego “Añadir a pantalla de inicio”."
                : "Aparece en tu menú de compartir desde Instagram, TikTok y YouTube."}
            </p>
            {!iosHint && (
              <button
                onClick={install}
                data-testid="install-prompt-btn"
                className="mt-3 px-4 py-2 rounded-full bg-[hsl(var(--primary))] text-white text-sm font-semibold btn-press"
              >
                Instalar MIZETA
              </button>
            )}
          </div>
          <button onClick={dismiss} aria-label="Cerrar" data-testid="install-prompt-dismiss" className="text-[hsl(var(--muted-foreground))] btn-press">
            <X size={18} />
          </button>
        </div>
      </div>
    </div>
  );
}
